import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteProjectsCompanyRoleSearchesQuery({
  params,
  projectId,
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['projects', projectId, 'companyRoleSearches', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post(
        `/projects/${projectId}/company_role_searches`,
        { company_role_search: { ...params, page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) => formatInfiniteData({ data }),
    ...queryOptions,
  });
}
